<div class="app-container">
  <div class="header">
    <app-header-view [puzzleId]="currentPuzzle().id"></app-header-view>
  </div>

  <div class="row g-0">
    <div class="col-12 col-md-8">
      <div class="board">
        <app-puzzle-view #puzzleView [puzzle]="currentPuzzle()" (completed)="onPuzzleCompleted()"></app-puzzle-view>
      </div>
    </div>

    <div class="col-12 col-md-4">
      <div class="info h-100">
        <app-puzzle-info-view #puzzleInfoView [puzzle]="currentPuzzle()" (goToNextPuzzle)="goToNextPuzzle()"
                              (showHint)="puzzleView.showHint()"></app-puzzle-info-view>
      </div>
    </div>
  </div>
</div>
